import { memo } from "react";
import { useSelector } from "react-redux";
import SoftBox from "components/SoftBox";
import classNames from "classnames";
import CustomNodeHandle from "layouts/Flow Designer/components/CustomNodes/components/CustomNodeHandle";

const styles = {
  hiddenNodeWrapper: {
    position: "relative",
    display: "flex",
    width: "1px ",
    height: "1px",
    backgroundColor: "transparent"
  }
};

function HiddenNode() {
  const { isVerticalCanvasDirection } = useSelector((state) => state?.designer?.settings);

  const divClass = classNames({
    isVertical: isVerticalCanvasDirection
  });

  return (
    <SoftBox
      sx={styles.hiddenNodeWrapper}
      className={`${divClass} custom-node-wrapper hidden-node`}
    >
      <CustomNodeHandle isTarget isHiddenNode />
      <CustomNodeHandle isHiddenNode />
    </SoftBox>
  );
}
export default memo(HiddenNode);
